module.exports = __webpack_public_path__ + "static/media/rewards.2c497aab.png";